import { render, staticRenderFns } from "./UserCreation.vue?vue&type=template&id=635bf1f0&"
import script from "./UserCreation.vue?vue&type=script&lang=js&"
export * from "./UserCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports